<template>
    <ul class="list-unstyled multi-steps">
        <li :class="{'is-active' : progress.step === 'from'}"><div>{{valueFrom}}</div>{{ $t('components.progress-bar.from') }}</li>
        <li :class="{'is-active' : progress.step === 'to'}"><div>{{valueTo}}</div>{{ $t('components.progress-bar.to') }}</li>
        <li :class="{'is-active' : progress.step === 'dates'}"><div>{{valueDates}}</div>{{ $t('components.progress-bar.dates') }}</li>
        <li :class="{'is-active' : progress.step === 'end'}" style="display:none;"></li>
    </ul>
</template>

<script>
    export default {
        name: "AddAlertProgress",
        props: ['progress'],
        data() {
            return {
                valueFrom: '...',
                valueTo: '...',
                valueDates: '...'
            }
        },
        watch: {
            progress: function(prog) {
                switch(prog.step) {
                    case 'to':
                        this.valueFrom = prog.value;
                        this.valueTo = '...';
                        break;

                    case 'from':
                        this.valueFrom = prog.value;
                        break;

                    case 'dates':
                        this.valueTo = prog.value;
                        break;

                    case 'end':
                        this.valueDates = prog.value;
                        break;

                    default:
                        break;
                }

            }
        }
    }
</script>

<style scoped>
    ul {
        padding: 0;
        margin: .5em auto;
        font-family: 'Nunito', sans-serif;
    }

    .multi-steps {
        display: table;
        table-layout: fixed;
        width: 100%;
    }

    .multi-steps > li {
        text-align: center;
        display: table-cell;
        position: relative;
        color: #f05;
        font-size: .9em;
    }

    .multi-steps > li div {
        background-color: #f05;
        height: 1.6em;
        border: 2px solid #f05;
        border-radius: .8em;
        width: 3em;
        text-align: center;
        color: #fff;
        line-height: 1.4em;
        margin: 0 auto .4em auto;
        font-weight: bold;
    }

    /* current step */
    .multi-steps > li.is-active div {
        background-color: #fff;
        color: #f05;
    }

    /* line after last completed step */
    .multi-steps > li.is-active:after, .multi-steps > li.is-active ~ li:after {
        background-color: #aaa;
    }

    /* line between completed steps */
    .multi-steps > li:after {
        content: '';
        height: 2px;
        width: 100%;
        background-color: #f05;
        position: absolute;
        top: .75em;
        left: 50%;
        z-index: -1;
    }

    /* line after last step circle */
    .multi-steps > li:nth-last-child(2):after {
        display: none;
    }

    /* legend color of uncompleted steps */
    .multi-steps > li.is-active ~ li {
        color: #888;
    }

    /* colors of circle from uncompleted steps */
    .multi-steps > li.is-active ~ li div {
        background-color: #fff;
        border-color: #aaa;
        color: #aaa;
    }

    /* unknown
.multi-steps > li.is-active:before {
    background-color: #fff;
    border-color: #f05;
}*/

    /* unknown
.multi-steps > li.is-active:before, .multi-steps > li.is-active ~ li:before {
    font-family: inherit;
    font-weight: 700;
}*/
</style>